import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { HelpCircle } from 'lucide-react';

interface TourButtonProps {
  onClick: () => void;
}

export function TourButton({ onClick }: Readonly<TourButtonProps>) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="default"
            size="icon"
            onClick={onClick}
            className="h-9 w-9"
            style={{ zIndex: 9999 }}
          >
            <HelpCircle className="h-5 w-5" />
            <span className="sr-only">Start Product Tour</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Start Product Tour</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
